module.exports = __webpack_public_path__ + "img/9788952745194.f98de8c6.jpg";